import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import withInsightPolarity from 'email-management-lib/refactor/components/manage/frameworkTable/withInsightPolarity';
import { jsx as _jsx } from "react/jsx-runtime";
function StatsRateCell({
  crmObject,
  propertyName
}) {
  const value = Number(getPropertyValue(crmObject, propertyName) || '0');
  return /*#__PURE__*/_jsx(FormattedPercentage, {
    precision: 2,
    value: value
  });
}
export default withInsightPolarity(StatsRateCell);